import React from 'react';

import { Location } from '~commonInfra/utils/Location';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

export function DiscardChangesDialog(title: string) {
    const discardChangesAction = () => {
        const urls = siteUrlsSelector(getAppStore().getState());
        Location.instance.setUrl(urls.settingsAuthenticationUrl());
        return Promise.resolve();
    };

    const dialogInstance = openReactActionDialog({
        title: title,
        bodyComponent: discardChangesProviderBody,
        initialBodyProps: {},
        initialDialogState: {},
        actionName: Messages.siteAuthenticationLeavePage(),
        cancelButtonText: Messages.siteAuthenticationContinueEditing(),
        isActionDelete: false,
        action: discardChangesAction,
        dialogWidth: TabDialogWidth.width375px,
        dismissDialogOnActionFailed: true,
    });

    return Promise.resolve(dialogInstance.result);
}


function discardChangesProviderBody() {
    return (
        <>
            <p>{Messages.siteAuthenticationDiscardChangesDesc1()}</p>
            <p/>
            <p>{Messages.siteAuthenticationDiscardChangesDesc2()}</p>
        </>
    );
}